const SIGN_UP_METHOD = Object.freeze({
  admin: 'admin_sign_up',
  self: 'self_sign_up',
});

export default SIGN_UP_METHOD;
